import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { solicitationListHeaderStyles } from './Column.styles';

interface ISolicitationStatusProps {
	status?: string;
}

const styles = css`
	display: flex;
	width: 120px;
	max-width: 120px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: status;
		justify-content: flex-end;
		width: max-content;
	}
`;

const Status = styled.div`
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};
	min-width: fit-content;
	padding: ${Css.pxToRem(11)} ${Css.pxToRem(16)};
	background-color: ${Color.Neutral2};
	border-radius: 4px;
	height: fit-content;
	text-align: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(9)} ${Css.pxToRem(14)};
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Status</StyledHeader>;
}

export function Cell({ status }: ISolicitationStatusProps) {
	return (
		<StyledCell css={styles}>
			{status ? <Status>{status}</Status> : '-'}
		</StyledCell>
	);
}
